
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.033 2.885c0 .792-.198 1.445-.596 1.964-.517.669-1.373 1.005-2.571 1.005H2.344v3.061H0V0h3.824c1.088 0 1.914.301 2.478.904.487.517.731 1.178.731 1.981m-2.345.026c0-.359-.109-.646-.33-.86-.222-.215-.598-.322-1.129-.322h-.885v2.396h.879c.572 0 .962-.119 1.175-.354.194-.211.29-.499.29-.86","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    